import { Input } from './styles'

export default Input